import React from "react";

const STATUS_STYLES = {
  NOT_VIEWED: { backgroundColor: "#FFB6B6", color: "#E80505" },
  VIEWED: { backgroundColor: "#A7E9FF", color: "#007299" },
  VALID: { backgroundColor: "#9FEAA4", color: "#008026" },
  CANCELED: { backgroundColor: "#FED7D7", color: "#822727" },
  COMPLETED: { backgroundColor: "#A7E9FF", color: "#007299"},
};

const labels = {
  NOT_VIEWED: "Не просмотрен",
  VIEWED: "Просмотрен",
  VALID: "Действует",
  CANCELED: "Закрыт",
  COMPLETED: "Завершён",
};

export const getDocumentStatusBadge = (status) => {
  return (
    <span className="table-status nowrap" style={STATUS_STYLES[status]}>
      {labels[status] || status}
    </span>
  );
};
